import PropTypes from 'prop-types';

// The server pre-renders this exact markup (lib/prerender.js INTRO_STYLE) so the
// heading paints before the JavaScript loads. Change both together.
const styles = {
  container: { padding: '40px 0', textAlign: 'center' },
  title: { fontSize: '2.5rem', marginBottom: '15px', fontWeight: 'bold' },
  text: { fontSize: '1.2rem', color: '#666', marginBottom: '20px' },
};

/** Big centred page heading with one line of introduction. */
const PageIntro = ({ title, text }) => (
  <div style={styles.container}>
    <h1 style={styles.title}>{title}</h1>
    <p style={styles.text}>{text}</p>
  </div>
);

PageIntro.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default PageIntro;
